import emitter from "tiny-emitter/instance";
/**
 * Register an event bus to communicate between components without going thru parent or the store
 */
export const eventBus = {
  $on: (...args) => emitter.on(...args),
  $once: (...args) => emitter.once(...args),
  $off: (...args) => emitter.off(...args),
  $emit: (...args) => emitter.emit(...args),
};
